import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BreakevenAnalysis from './BreakevenAnalysis'
import TotalCosts from './TotalCosts'
import BlankCard from '../../../../components/ui/cards/BlankCard'

/**
 * @const generateBreakevenChart
 * @param data
 */
const generateBreakevenChart = data =>
  new window.FacetChart({
    container: document.getElementById('breakevenChart'),
    toolbar: { export: false, logScale: false, back: false },
    data: { preloaded: data && !!data.length && data[4].analysis },
    area: { height: 350 },
    series: [
      {
        data: { field: 'cumm' },
        id: 's3f',
        name: 'Education Value',
        type: 'line',
        style: {
          fillColor: '#FFC19E',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          lineWidth: 5,
          smoothing: true,
          lineColor: '#ff8b1a',
          marker: {
            shape: 'circle',
            width: 12,
            fillColor: '#ffffff',
            lineColor: '#ff8b1a',
          },
        },
      },
      {
        data: { field: 'total_investment' },
        id: 's5',
        name: 'Total Investment',
        type: 'line',
        style: {
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          lineWidth: 5,
          smoothing: true,
          lineColor: '#EE6352',
        },
      },
    ],
  })

/**
 * @const generateAmortizationChart
 * @param data
 */
const generateAmortizationChart = data =>
  new window.FacetChart({
    container: document.getElementById('amortizationChart'),
    toolbar: { export: false, logScale: false, back: false, zoomOut: false },
    data: { preloaded: data[4].analysis },
    valueAxis: {
      va1: {
        side: 'left',
        position: 'outside',
      },
    },
    area: { height: 350, style: {} },
    series: [
      {
        data: {
          field: 'principal_paid',
        },
        id: 's5',
        name: 'Principal Payment',
        type: 'line',
        valueAxis: 'va1',
        style: {
          lineWidth: 5,
          smoothing: true,
          lineColor: '#FF9553',
          marker: {
            shape: 'circle',
            width: 8,
            fillColor: '#FFF',
            lineColor: '#FF9553',
          },
        },
      },
      {
        data: {
          field: 'interest_paid',
        },
        id: 's3',
        name: 'Interest Payment',
        type: 'line',
        valueAxis: 'va1',
        style: {
          lineWidth: 5,
          smoothing: true,
          lineColor: '#4596F1',
          marker: {
            shape: 'circle',
            width: 8,
            fillColor: '#FFF',
            lineColor: '#4596F1',
          },
        },
      },
    ],
    stacks: {
      default: {
        type: 'normal',
      },
    },
  })

export default class DeepDiveResultsWrapper extends Component {
  static propTypes = {
    chartData: PropTypes.any,
    onToggleTab: PropTypes.func.isRequired,
    updateChartsData: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeLinkIndex: 0,
    }

    this.changeTab = nextActiveLinkIndex => {
      if (nextActiveLinkIndex === 1) {
      }
      setTimeout(() => {
        this.props.updateChartsData()
      }, 100)

      this.setState({ activeLinkIndex: nextActiveLinkIndex })
      this.props.onToggleTab(nextActiveLinkIndex === 1)
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      })
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.breakevenChart = generateBreakevenChart(this.props.chartData)
      this.amortizationChart = generateAmortizationChart(this.props.chartData)
    }, 250)
  }

  componentDidUpdate(prevProps) {
    const { chartData } = this.props
    if (prevProps.chartData !== chartData) {
      if (this.breakevenChart) {
        this.breakevenChart.replaceData(chartData[4].analysis)
      }
      if (this.amortizationChart) {
        this.amortizationChart.replaceData(chartData[4].analysis)
      }
    }
  }

  render() {
    const { activeLinkIndex } = this.state
    const { chartData, salaryWithDegree, salaryWithoutDegree } = this.props

    return (
      <div>
        <div className="row chrome-tab-wrapper p-0 ml-3">
          <div
            className={`chrome-tab ${activeLinkIndex === 0 && 'active'}`}
            onClick={() => this.changeTab(0)}
            style={{ padding: '5px 15px', fontSize: 16 }}
          >
            <i className="fal fa-usd-circle" style={{ color: 'gray' }} /> Total Costs
          </div>
          <div
            id="breakeven"
            className={`chrome-tab ${activeLinkIndex === 1 && 'active'}`}
            onClick={() => this.changeTab(1)}
            style={{ padding: '5px 15px', fontSize: 16, maxWidth: 200 }}
          >
            <i className="fal fa-chart-line" style={{ color: 'gray' }} /> Breakeven Analysis
          </div>
        </div>
        <BlankCard style={{ boxShadow: 'none' }}>
          <div>
            {activeLinkIndex === 0 && chartData && <TotalCosts data={chartData[1].analysis[0]} />}

            {activeLinkIndex === 1 && chartData && (
              <BreakevenAnalysis
                data={chartData[3].analysis[0]}
                salaryWithDegree={salaryWithDegree}
                salaryWithoutDegree={salaryWithoutDegree}
              />
            )}

            <div
              style={{
                marginTop: 10,
                display: activeLinkIndex !== 1 ? 'none' : 'inherit',
              }}
            >
              <h5>Breakeven Time Chart</h5>
              <div id="breakevenChart" style={{ margin: '0 -0.75rem 0 -1.25rem' }} />
            </div>

            <div
              style={{
                marginTop: 10,
                display: activeLinkIndex !== 0 ? 'none' : 'inherit',
              }}
            >
              <div>
                <h5>Your Loan Amortization</h5>
                <div id="amortizationChart" style={{ margin: '0 -0.75rem 0 -1.25rem' }} />
              </div>
            </div>
          </div>
        </BlankCard>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/DeepDiveResultsWrapper.js